function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { transition_default } from "./chunk-SIH73G3H.mjs";
import { z_index_default } from "./chunk-45VJLTIL.mjs";
import { borders_default } from "./chunk-B75T2J64.mjs";
import { breakpoints_default } from "./chunk-TXLFBUTF.mjs";
import { colors_default } from "./chunk-E47HH2QS.mjs";
import { radius_default } from "./chunk-VIVTPWHP.mjs";
import { shadows_default } from "./chunk-IZUFFCXS.mjs";
import { blur_default } from "./chunk-HQ6WXDYV.mjs";
import { typography_default } from "./chunk-6XA2KDUD.mjs";
import { sizes_default } from "./chunk-NJCYBKFH.mjs";
import { spacing } from "./chunk-V7WMN6TQ.mjs"; // src/foundations/index.ts

var foundations = _objectSpread(_objectSpread({
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default
}, typography_default), {}, {
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
});

export { foundations };